// PersonalizationBadge.jsx - Badge to indicate products can be personalized
import React from 'react';
import './PersonalizationBadge.css';

const PersonalizationBadge = ({ variant = 'default', size = 'small' }) => {
  // Card variant shows just "PERSONALISE" without icon for Bold & Modern design
  if (variant === 'card') {
    return (
      <div className={`personalization-badge ${variant} ${size}`}>
        <span className="badge-text">Personalise</span>
      </div>
    );
  }

  return (
    <div className={`personalization-badge ${variant} ${size}`}>
      <span className="badge-icon">✨</span>
      <span className="badge-text">Personalise Me</span>
    </div>
  );
};

export default PersonalizationBadge;
